import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { HttpResponseState } from 'src/app/core/modals/response-type';
import { UploadService } from '../../services/upload.service';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Image } from 'src/app/modules/catalog/product/store/variant.model';

class ImageSnippet {
  constructor(public src: string, public file: File) { }
}

@Component({
    selector: 'app-product-image',
    templateUrl: './product-image.component.html',
    styleUrls: ['./product-image.component.scss'],
    standalone: false
})

export class ProductImageComponent implements OnInit {
  @Input() data: Image[] = [];
  @Output() fileUploaded = new EventEmitter<File>();

  subscribe: Subscription = new Subscription();
  environment: any = environment;
  selectedImages: Array<any> = [];
  defaultImage: any = true;
  urls: any = [];
  selectedFile: Array<ImageSnippet> = [];
  showCropper: boolean = true;
  imageChangedEvent: any = '';
  croppedImage: any = '';
  base64Image: any = '';
  scale = 1;
  transform: ImageTransform = {};
  canvasRotation = 0;
  containWithinAspectRatio = true;
  rotation = 0;
  selectedFiles: any = [];
  uploadProgress: number = 0;
  errors: Array<any> = [];
  uploadedFilePath: any = [];

  @Output() multipleImages = new EventEmitter<any>();

  constructor(private modalService: NgbModal,
    private uploadService: UploadService,
  ) { }

  ngOnInit(): void {
    if (this.data?.length > 0) {
      this.updateImages();
    }
  }

  updateImages() {
    this.defaultImage = false;
    this.data.forEach((image) => {
      this.selectedImages.push(image);
      this.selectedFiles.push(image);
      this.multipleImages.emit(this.selectedFiles);
      if (this.selectedImages.length <= 8) {
        this.uploadProgress = 100;
        this.uploadedFilePath.push(environment.mediaUrl + image.path);
      }
    });
  }

  onFileSelected(event: any) {
    const files = event.target.files;
    const slicedFiles = files.length >= 8 ? Array.from(files).slice(0, 8) : files;

    for (const file of slicedFiles) {
      this.upload(file);
      let tempfile: ImageSnippet;
      const reader = new FileReader();
      reader.addEventListener('load', (e: any) => {
        this.defaultImage = false;
        tempfile = new ImageSnippet(e.target.result, file);
      });
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (this.selectedImages.length <= 8) {
          this.selectedImages.push(reader.result as string);
        }
        else {
        }
      };
    }
  }

  async upload(file: File) {

    let resp: any;

    if (!file) {
      this.errors.push('Please select a file to upload.');
      return this.errors;
    }

    try {
      const response: any = await (
        this.uploadService.mediaCreate(file) // Or direct HTTP request
      ).toPromise();

      if (response.ok && response.status === 201) {
        this.uploadProgress = 100;
        resp = response.body?.result; // Extract data from response
        this.defaultImage = false;
        this.selectedFiles.push({ id: resp.fileid, path: resp.filepath });
        if (this.selectedImages.length <= 8) {
          this.uploadedFilePath.push(environment.mediaUrl + resp.filepath);
        }
        else {
        }
        this.multipleImages.emit(this.selectedFiles);

      } else {
        throw new Error('Upload failed with status: ' + response.status);
      }
    } catch (error) {
      this.uploadProgress = 0;
      this.errors.push('Upload failed: ' + error.message);
    }
  }

  crop(event, content, i) {
    this.showCropper = true;
    console.log(this.uploadedFilePath);
    console.log(event);
    this.base64Image = this.uploadedFilePath[i];
    console.log(this.base64Image);
    this.imageChangedEvent = event;
    this.modalService.open(content, { size: 'lg' });
  }

  fileChangeEvent(event: any) {
    this.imageChangedEvent = event;
  }

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }

  imageLoaded() {
    this.showCropper = true;
  }

  cropperReady(sourceImageDimensions: Dimensions) {
  }

  loadImageFailed() {
  }

  remove(index) {
    this.uploadedFilePath.splice(index, 1);
    const data: number = this.selectedFiles.splice(index, 1);
    this.delete(data[0]);
    this.multipleImages.emit(this.selectedFiles);
  }

  async delete(id: number) {
    const postData = {
      id: id,
    };
    const deleteMedia = this.uploadService.delete(postData).subscribe((res: HttpResponseState) => {

    }
    );
    this.subscribe.add(deleteMedia);
  }

  zoomIn() {
    this.scale += .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  zoomOut() {
    this.scale -= .1;
    this.transform = {
      ...this.transform,
      scale: this.scale
    };
  }

  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }

  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH
    };
  }

  flipVertical() {
    this.transform = {
      ...this.transform,
      flipV: !this.transform.flipV
    };
  }

  flipHorizontal() {
    this.transform = {
      ...this.transform,
      flipH: !this.transform.flipH
    };
  }

  resetImage() {
    this.scale = 1;
    this.rotation = 0;
    this.canvasRotation = 0;
    this.transform = {};
  }

}
